import React from 'react';
import { Image as ImageIcon } from 'lucide-react';
import { Card } from './ui/card';
import { scellantGalleryImages } from '../data/mock';

const ScellantGallery = () => {
  return (
    <section id="scellant-gallery" className="py-14 md:py-24 bg-gradient-to-b from-black to-gray-900">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-8 md:mb-16">
          <div className="inline-flex items-center space-x-2 bg-red-900/30 border border-red-500/30 rounded-full px-4 py-2 mb-4">
            <ImageIcon size={18} className="text-red-500" />
            <span className="text-sm font-semibold text-white">Nos Réalisations</span>
          </div>
          <h2 className="text-3xl md:text-5xl font-bold mb-4">
            <span className="text-white">Résultats</span>{' '}
            <span className="bg-gradient-to-r from-red-600 to-red-500 bg-clip-text text-transparent">
              avant / après
            </span>
          </h2>
          <p className="text-base md:text-xl text-gray-400">
            Découvrez la transformation spectaculaire de nos projets.
          </p>
        </div>

        {/* Gallery Grid - 2x2 on all screens */}
        <div className="grid grid-cols-2 gap-2 md:gap-6 mb-8 md:mb-12">
          {scellantGalleryImages.map((image, index) => (
            <Card
              key={image.id}
              className="group relative overflow-hidden border border-red-500/20 bg-gray-900 shadow-lg hover:shadow-2xl hover:shadow-red-500/20 transition-all duration-300"
            >
              <div className="aspect-square md:aspect-[16/10] overflow-hidden">
                <img
                  src={image.url}
                  alt={image.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                  <div className="p-3 md:p-6 text-white">
                    <h3 className="text-xs md:text-xl font-bold">{image.title}</h3>
                  </div>
                </div>
              </div>
            </Card>
          ))}
        </div>

        {/* Process Info */}
        <div className="max-w-3xl mx-auto bg-gray-900 border border-red-500/20 rounded-xl md:rounded-2xl p-5 md:p-8 shadow-lg">
          <h3 className="text-lg md:text-2xl font-bold text-white mb-3 md:mb-4 text-center">
            Notre processus en 3 étapes
          </h3>
          <div className="grid grid-cols-3 gap-3 md:gap-6 mt-4 md:mt-8">
            <div className="text-center">
              <div className="w-9 h-9 md:w-12 md:h-12 bg-gradient-to-r from-red-600 to-red-500 text-white rounded-full flex items-center justify-center font-bold text-base md:text-xl mx-auto mb-2 md:mb-3">
                1
              </div>
              <h4 className="font-semibold text-white text-xs md:text-base mb-1">Préparation</h4>
              <p className="text-[10px] md:text-sm text-gray-400">Nettoyage et inspection</p>
            </div>
            <div className="text-center">
              <div className="w-9 h-9 md:w-12 md:h-12 bg-gradient-to-r from-red-600 to-red-500 text-white rounded-full flex items-center justify-center font-bold text-base md:text-xl mx-auto mb-2 md:mb-3">
                2
              </div>
              <h4 className="font-semibold text-white text-xs md:text-base mb-1">Application</h4>
              <p className="text-[10px] md:text-sm text-gray-400">Pulvérisation uniforme</p>
            </div>
            <div className="text-center">
              <div className="w-9 h-9 md:w-12 md:h-12 bg-gradient-to-r from-red-600 to-red-500 text-white rounded-full flex items-center justify-center font-bold text-base md:text-xl mx-auto mb-2 md:mb-3">
                3
              </div>
              <h4 className="font-semibold text-white text-xs md:text-base mb-1">Séchage</h4>
              <p className="text-[10px] md:text-sm text-gray-400">Protection durable</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ScellantGallery;
